// Hook has been changed to directly return Danish localization, since international use has been
// de-scoped for the forseeable future.

import { translations as defaultTranslations } from '~src/localization/da';

export const useLocalization = () => defaultTranslations;
